//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LocationAddressUpdateItem } from './LocationAddressUpdateItem';
import { EventColorEnum, EventLocationIcon } from './Enums';

export class EventLocationUpdateItem extends ItemBase {
    Address?: LocationAddressUpdateItem | null;
    Color?: EventColorEnum;
    Icon?: EventLocationIcon;
    Name?: string | null;
    Description?: string | null;

    constructor(initializer?: Partial<EventLocationUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventLocationUpdateItem";
}
